import { render } from "./Activate.vue?vue&type=template&id=af51ec48&scoped=true"
import script from "./Activate.vue?vue&type=script&lang=ts"
export * from "./Activate.vue?vue&type=script&lang=ts"

import "./Activate.vue?vue&type=style&index=0&id=af51ec48&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af51ec48"

export default script